const VERSION = {
  number: "1.52.3",
  nickname: "Reflection",
}

export default VERSION
